import { Component } from '@angular/core';
import { BasePage } from '../BasePage';
import { InvoiceService } from '../../models/invoices/invoiceService';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { UIErrorHandler } from '../../core/uiErrorHandler';


@Component({
  selector: 'app-external-invoice',
  templateUrl: './external-invoice.component.html',
  standalone: false,
})
export class ExternalInvoiceComponent extends BasePage {

  merchantName: string = '';
  invoiceNumber: string = '';
  customerEmail: string = '';
  invoiceId: string = '';
  errorMessage: boolean = false;

  constructor(
    private invoiceService: InvoiceService,
    private route: ActivatedRoute,  
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.merchantName = this.route.snapshot.params['merchantName'].replaceAll('_', ' ');
  }

  getInvoice() {
    let invoiceNumberValue = 0;
    if (this.invoiceNumber.search(/-/) !== -1) {
      invoiceNumberValue = Number(this.invoiceNumber.split('-')[1]);
    } else {
      invoiceNumberValue = Number(this.invoiceNumber);
    }
    this.invoiceService.getInvoiceIdForExternalInvoice(this.merchantName, invoiceNumberValue.toString(), 'campfire', this.customerEmail).then((invoiceId) => {
      const url = environment.portalUrl + `/payable-invoice?id=` + invoiceId;
      window.location.href = url;
    }).catch((error) => {
      console.error(error);
      this.errorMessage = true;
    });
  }
}
